import * as firebase from 'firebase/app';
import UIkit from 'uikit';
import {isNull} from 'lodash';

class ArticleModel {
    constructor(table) {
        this.ref = firebase.database().ref(table);
        this.table = table;
        this.articleKey = this.ref.push().key;
        this.save = firebase.database().ref(table + '/' + this.articleKey);
        this.auth = firebase.auth().currentUser;
    }
    
    getArticle() {
        return new Promise(resolve => {
            return this.ref.orderByChild('like').on('value', snapshot => resolve(snapshot));
        });
    }
    
    getArticleOrderBy(name) {
        let table = this.ref.orderByChild(name);
        
        return new Promise(resolve => table.startAt().on('value', snapshot => resolve(snapshot)));
    }
    
    getCommentsArticle(key) {
        var comments = firebase.database().ref(this.table + '/' + key + '/comments'),
            response;
            
        comments.on('value', snapshot => {
            if (snapshot.exists()) {
                response = snapshot.val().total;
            } else {
                response = null;
            }
        });
        return response;
    }
    
    getLike(key) {
        var like = firebase.database().ref(this.table + '/' + key + '/like'),
            response;
        
        like.on('value', snapshot => {
            if (snapshot.exists()) {
                response = snapshot.val();
            } else {
                response = 0;
            }
        });
        
        return response;
    }
    
    getShare(key) {
        var share = firebase.database().ref(this.table + '/' + key + '/share'),
            response;
        
        share.on('value', snapshot => response = snapshot.exists() ? snapshot.val() : 0);
        
        return response;
    }
    
    setLike(key, total) {
        var like = firebase.database().ref(this.table + '/' + key + '/like');
        
        like.update({
            "total": total
        });
    }
    
    setShare(key, total) {
        var share = firebase.database().ref(this.table + '/' + key + '/share');
        
        share.update({
            "total": total
        });
    }
    
    async saveArticle(data) {
        await this.save.set(data, error => {
            if (error) {
                UIkit.notification('<span uk-icon="icon: warning"></span>&nbsp;' + error.message, {
                    status: 'warning',
                    timeout: 2000
                });
                
                return false;
            } else {
                UIkit.notification('<span uk-icon="icon: check"></span>&nbsp;artikel berhasil ditambahkan dan dipajang.', {
                    status: 'success',
                    timeout: 2000
                });
                
                return true;
            }
        });
    }
}

export default ArticleModel;